import { Component, OnInit, ViewChild } from '@angular/core';
import { HistoricoEventoService } from '../../../../../services/database/historico-evento.service';
import { TranslateService } from '@ngx-translate/core';
import { CustomTableComponent, CustomTitle, DataColumnType, ICustomTable } from 'lib-base';
import { firstValueFrom, forkJoin } from 'rxjs';
import { ITipoTramiteHistorico } from '../../../../../shared/interfaces/database/configuracion';
import { DialogModule } from 'primeng/dialog';
import { TabViewModule } from 'primeng/tabview';

@Component({
  selector: 'app-admin-tipo-tramite-historial',
  standalone: true,
  imports: [CustomTableComponent, DialogModule, CustomTitle, TabViewModule],
  templateUrl: './admin-tipo-tramite-historial.component.html',
  styleUrl: './admin-tipo-tramite-historial.component.scss'
})
export class AdminTipoTramiteHistorialComponent implements OnInit {

  title: string = 'title';
  displayModal: boolean = false;
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  constructor(private readonly _hes: HistoricoEventoService, private readonly _t: TranslateService) { }

  ngOnInit(): void {
    this.translate().then(() => {
      this.configColumns();
    });
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      nombre: this._t.get('common.nombre'),
      descripcionBreve: this._t.get('common.descripcionBreve'),
      categorizacion: this._t.get('common.categorizacion'),
      plazo: this._t.get('common.plazo'),
      tipoDePlazo: this._t.get('common.tipoDePlazo'),
      requierePago: this._t.get('common.requierePago'),
      produccion: this._t.get('common.produccion'),
      hojaDeVidaTramite: this._t.get('common.hojaDeVidaTramite'),
      formulario: this._t.get('common.formulario'),
      fuenteDePago: this._t.get('common.fuenteDePago'),
      usuarioEvento: this._t.get('common.usuarioEvento'),
      evento: this._t.get('common.evento'),
      fechaActualizacion: this._t.get('common.fechaActualizacion'),
      historialDeCambiosDeLosTramites: this._t.get('msg.historialDeCambiosDeLosTramites'),
      iac: this._t.get('common.iac')
    }));
    this.title = this.trans.historialDeCambiosDeLosTramites;
  }

  private configColumns() {
    this.customTable = {
      header: {
        //esto existe para las columnas opcionales
      },
      columns: [
        {
          field: 'descripcion',
          header: this.trans.nombre,
          width: '10rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'descripcionBreve',
          header: this.trans.descripcionBreve,
          width: '10rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'categorizacionDescripcion',
          header: this.trans.categorizacion,
          width: '8rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'plazo',
          header: this.trans.plazo,
          sort: false,
          width: '6rem',
          dataType: DataColumnType.NUMBER,
        },
        {
          field: 'tipoPlazoDescripcion',
          header: this.trans.tipoDePlazo,
          width: '8rem',
          dataType: DataColumnType.TEXT,
        },
        {
          field: 'requierePago',
          header: this.trans.requierePago,
          width: '6rem',
          dataType: DataColumnType.CHECK
        },
        {
          field: 'produccion',
          header: this.trans.produccion,
          width: '6rem',
          dataType: DataColumnType.CHECK
        },
        {
          field: 'formularioNombre',
          header: this.trans.formulario,
          width: '9rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'tiposDocumentoReciboPagoDescripcion',
          header: this.trans.fuenteDePago,
          width: '9rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'iac',
          header: this.trans.iac,
          width: '9rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'correo',
          header: 'Correo',
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'direccion',
          header: 'Dirección',
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'horariosAtencion',
          header: 'Horarios de Atención',
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'nombreBanco',
          header: 'Nombre Banco',
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'norma',
          header: 'Norma',
          width: '8rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'numeroCuenta',
          header: 'Número de Cuenta',
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'observaciones',
          header: 'Observaciones',
          width: '12rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'periodo',
          header: 'Periodo',
          width: '8rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'relacion',
          header: 'Relación',
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'telefono',
          header: 'Teléfono',
          width: '8rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'tipoCuenta',
          header: 'Tipo de Cuenta',
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'requisitos',
          header: 'Requisitos',
          width: '12rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'ruta',
          header: 'Ruta',
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'usuarioEvento',
          header: this.trans.usuarioEvento,
          width: '5rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'evento',
          header: this.trans.evento,
          width: '5rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaActualizacion',
          header: this.trans.fechaActualizacion,
          width: '5rem',
          dataType: DataColumnType.DATE
        },
      ],
      settings: {
        columnToggle: {
          showColumnToggle: true,
          maxSelectedLabels: 7
        }
      }
    } as ICustomTable;

  }

  show(tipoTramiteId: number) {
    this.displayModal = true;
    this.loadHistorial(tipoTramiteId);
  }

  hide() {
    this.displayModal = false;
  }

  showEliminado() {
    this.displayModal = true;
    this.loadHistorialEliminado();
  }

  loadHistorial(tipoTramiteId: number) {
    this._hes.getTipoTramiteHistorico(tipoTramiteId).subscribe({
      next: (data: ITipoTramiteHistorico[]) => {
        this.customTableComponent.data = data;
      }
    });
  }

  loadHistorialEliminado() {
    this._hes.getTipoTramiteHistoricoEliminados().subscribe({
      next: (data: ITipoTramiteHistorico[]) => {
        this.customTableComponent.data = data;
      }
    });
  }
}
